/* eslint-disable @typescript-eslint/no-explicit-any */
export default defineNuxtPlugin({
  name: 'openfeature',
  setup: async (nuxtApp) => {
    const { registerFeatureFlagProvider } = await import(
      '../openfeature/client'
    )
    const client = await registerFeatureFlagProvider()
    nuxtApp.provide('openfeature', client)
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ;(window as any).of = client
  },
})
